export enum EstadosSolicitud {
	EnProceso = 1,
	PendientePago = 2,
	EnTramite = 3,
	Devuelto = 4,
	Aprobada = 5,
	Rechazada = 6,
	PendienteRenovacion = 7,
	PorDefinir = 8
}
